import React from 'react'
import PropTypes from 'prop-types'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { withStyles, CircularProgress } from '@material-ui/core'
import Button from 'components/ButtonMaterial'
import { bindActionCreators } from 'redux'
import { showFlashMessage, showFlashMessageOnUnexpectedError, updateUserAvatar } from 'actions'
import { connect } from 'react-redux'
import isempty from 'lodash.isempty'

const IMAGE_MAX_SIZE = process.env.REACT_APP_IMAGE_UPLOADER_MAX_SIZE
const base64DataRegEx = /^data:.+\/(.+);base64,(.*)$/

const getCroppedImg = (image, pixelCrop) => {
  const canvas = document.createElement('canvas')
  canvas.width = pixelCrop.width < IMAGE_MAX_SIZE ? pixelCrop.width : IMAGE_MAX_SIZE
  canvas.height = pixelCrop.height < IMAGE_MAX_SIZE ? pixelCrop.height : IMAGE_MAX_SIZE
  const ctx = canvas.getContext('2d')

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width < IMAGE_MAX_SIZE ? pixelCrop.width : IMAGE_MAX_SIZE,
    pixelCrop.height < IMAGE_MAX_SIZE ? pixelCrop.height : IMAGE_MAX_SIZE
  )

  // As Base64 string
  return canvas.toDataURL('image/jpeg')
}

const styles = theme => ({
  actionContainer: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  progress: {
    color: '#00bcb5',
  },
  reactCrop: {
    '& img': {
      maxHeight: 'inherit',
    },
  },
})

class InvestorChangeImage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      crop: {
        aspect: 1 / 1,
        x: 0,
        y: 0,
        width: 50,
      },
      isImageLoading: true,
    }
  }

  onImageLoaded = async (image, pixelCrop) => {
    this.imageRef = image
    const croppedImage = await getCroppedImg(this.imageRef, pixelCrop)
    this.setState({
      isImageLoading: false,
      croppedImage,
    })
  }

  onCropComplete = async (crop, pixelCrop) => {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImage = await getCroppedImg(this.imageRef, pixelCrop)
      this.setState({ croppedImage })
    }
  }

  onCropChange = crop => {
    this.setState({ crop })
  }

  onImageError = event => {
    this.props.showFlashMessage(true, 'Looks like there is something wrong with that image. Please try again.')
    this.props.handleBack()
  }

  handleUpdate = async () => {
    try {
      const data = this.state.croppedImage.match(base64DataRegEx)[2]
      if (!data) {
        throw Error('couldnt get a proper data for the cropped base64 img')
      }
      const response = await this.props.updateUserAvatar(data, this.props.user.token)
      if (isempty(response.errors)) {
        this.props.handleBack()
      }
    } catch (error) {
      this.props.showFlashMessageOnUnexpectedError(error)
    }
  }

  render() {
    const { crop, croppedImage, isImageLoading } = this.state
    const { classes, handleBack } = this.props

    const src = this.props.user.personalData.get('avatarUrl') || this.props.imageUploaded

    return (
      <div className={classes.reactCrop}>
        {src && (
          <React.Fragment>
            {isImageLoading && (
              <div>
                <CircularProgress className={classes.progress} />
              </div>
            )}
            <ReactCrop
              src={`${src}`}
              crossorigin="anonymous"
              crop={crop}
              onImageLoaded={this.onImageLoaded}
              onComplete={this.onCropComplete}
              onChange={this.onCropChange}
              onImageError={this.onImageError}
            />
          </React.Fragment>
        )}
        <div className={classes.actionContainer}>
          <Button style={{ width: '35%' }} onClick={handleBack} link>
            back
          </Button>
          <Button style={{ width: '45%' }} onClick={this.handleUpdate} disabled={!croppedImage}>
            update
          </Button>
        </div>
      </div>
    )
  }
}

InvestorChangeImage.propTypes = {
  user: PropTypes.object,
  imageUploaded: PropTypes.string,
  handleBack: PropTypes.func.isRequired,
  updateUserAvatar: PropTypes.func.isRequired,
  showFlashMessageOnUnexpectedError: PropTypes.func.isRequired,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showFlashMessageOnUnexpectedError,
      showFlashMessage,
      updateUserAvatar,
    },
    dispatch
  )
}

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps
  )(InvestorChangeImage)
)



// WEBPACK FOOTER //
// ./src/features/investorDashboard/components/InvestorChangeImage.js